import React from 'react';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import 'typeface-lato';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var DeviceSizes;
(function (DeviceSizes) {
    DeviceSizes["mobileS"] = "320px";
    DeviceSizes["mobileM"] = "375px";
    DeviceSizes["mobileL"] = "425px";
    DeviceSizes["tablet"] = "768px";
    DeviceSizes["laptop"] = "1024px";
    DeviceSizes["laptopL"] = "1440px";
    DeviceSizes["desktop"] = "2560px";
})(DeviceSizes || (DeviceSizes = {}));
var Devices = {
    mobileS: "(min-width: " + DeviceSizes.mobileS + ")",
    mobileM: "(min-width: " + DeviceSizes.mobileM + ")",
    mobileL: "(min-width: " + DeviceSizes.mobileL + ")",
    tablet: "(min-width: " + DeviceSizes.tablet + ")",
    laptop: "(min-width: " + DeviceSizes.laptop + ")",
    laptopL: "(min-width: " + DeviceSizes.laptopL + ")",
    desktop: "(min-width: " + DeviceSizes.desktop + ")",
    desktopL: "(min-width: " + DeviceSizes.desktop + ")"
};

var Blues = {
    darkest: '#1c4c5d',
    dark: '#27a3aa',
    light: '#48b6c4',
    lightest: '#70d6e3'
};
var Reds = {
    darkest: '#f35f20',
    dark: "#f76d23",
    light: "#fdac7b",
    lightest: '#ffd4bd'
};
var Oranges = {
    dark: '#ffbb31',
    normal: '#ffc982',
    light: '#ffebba'
};
var Greens = {
    dark: "#787642",
    normal: "#b1c9db",
    light: "#cce18a"
};
var Greys = {
    dark: '#2c2e35',
    normal: '#595b61',
    light: '#b0b1b3'
};
var colors = {
    Reds: Reds,
    Blues: Blues,
    Oranges: Oranges,
    Greens: Greens,
    Greys: Greys
};

var PalletContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex; \n    flex-direction: row;\n    width: 100%; \n    flex-wrap: wrap;\n\n"], ["\n    display: flex; \n    flex-direction: row;\n    width: 100%; \n    flex-wrap: wrap;\n\n"])));
var Outer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n     display :flex;\n     flex-direction:column;\n     align-items:center;\n"], ["\n     display :flex;\n     flex-direction:column;\n     align-items:center;\n"])));
var Swab = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex; \n    flex-direction: column;\n    align-items:center;\n"], ["\n    display: flex; \n    flex-direction: column;\n    align-items:center;\n"])));
var ColorBlock = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 200px;\n    height: 200px;\n    margin-right:20px;\n    background-color: ", ";\n    display:flex;\n    align-items:center;\n    justify-content:center;\n    \n"], ["\n    width: 200px;\n    height: 200px;\n    margin-right:20px;\n    background-color: ", ";\n    display:flex;\n    align-items:center;\n    justify-content:center;\n    \n"])), function (props) { return props.color; });
var ColorLabel = styled.h4(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color:white;\n    font-size:2rem;\n    \n"], ["\n    color:white;\n    font-size:2rem;\n    \n"])));
var Pallet = function (_a) {
    var colors = _a.colors, name = _a.name;
    return (React.createElement(Outer, null,
        React.createElement("h3", null, name),
        React.createElement(PalletContainer, null, Object.entries(colors).map(function (_a) {
            var variant = _a[0], hex = _a[1];
            return React.createElement(ColorBlock, { color: hex },
                React.createElement(ColorLabel, null, variant));
        }))));
};
var Swabs = function () {
    return (React.createElement("div", null, Object.entries(colors).map(function (_a) {
        var name = _a[0], colors = _a[1];
        return React.createElement(Pallet, { colors: colors, name: name });
    })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var theme = {
    borderRadius: '2px',
    typography: {
        header: '36px',
        body: '20px'
    },
    devices: Devices,
    colors: {
        blues: Blues,
        greens: Greens,
        greys: Greys,
        reds: Reds,
        oranges: Oranges
    }
};
var themeLight = __assign(__assign({}, theme), { colors: __assign({ main: Blues.dark, secondary: Reds.dark }, theme.colors), text: {
        main: Greys.dark,
        secondary: Greys.normal
    } });
var themeDark = __assign(__assign({}, theme), { typography: {
        header: '36px',
        body: '20px'
    }, colors: __assign({ main: Oranges.light, secondary: Reds.lightest }, theme.colors), text: {
        main: Greys.dark,
        secondary: Greys.light
    } });
var DCThemeProvider = function (_a) {
    var children = _a.children, _b = _a.variant;
    var GlobalStyle = createGlobalStyle(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n         #root {\n             font-size:16px;\n             width:100%;\n             height:100%;\n             margin:0px;\n             padding:0px;\n         }\n\n         body, head{\n             font-size:16px;\n             font-family: Lato, sans-serif;\n             width:100vw;\n             height:100vh;\n             margin:0px;\n             padding:0px;\n         }\n    "], ["\n         #root {\n             font-size:16px;\n             width:100%;\n             height:100%;\n             margin:0px;\n             padding:0px;\n         }\n\n         body, head{\n             font-size:16px;\n             font-family: Lato, sans-serif;\n             width:100vw;\n             height:100vh;\n             margin:0px;\n             padding:0px;\n         }\n    "])));
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(GlobalStyle, null),
        children));
};
var templateObject_1$1;

export { Blues, DCThemeProvider, DeviceSizes, Devices, Greens, Greys, Oranges, Reds, Swabs, colors, theme, themeDark, themeLight };
